// Sticky nav
const nav = document.getElementById('site-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  });
}

// Product filter buttons
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');
    const filter = this.dataset.filter;
    document.querySelectorAll('.product-card').forEach(card => {
      const tags = (card.dataset.category || '').split(',');
      if (filter === 'all' || tags.indexOf(filter) !== -1) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });
  });
});

// Add to cart (Shopify AJAX)
document.querySelectorAll('.btn-add-to-cart').forEach(btn => {
  btn.addEventListener('click', async function (e) {
    e.preventDefault();
    e.stopPropagation();
    const variantId = this.dataset.variantId;
    if (!variantId) return;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        const original = this.textContent;
        this.textContent = 'Added ✓';
        setTimeout(() => this.textContent = original, 2000);
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const counter = document.querySelector('.cart-count');
        if (counter) counter.textContent = cart.item_count;
      } else {
        const errData = await res.json();
        console.error('Add to cart failed:', errData);
      }
    } catch (err) {
      console.error('Add to cart error:', err);
    }
  });
});

// Product page: thumbnail gallery swap
document.querySelectorAll('.product-page__thumb').forEach(thumb => {
  thumb.addEventListener('click', function () {
    const full = this.dataset.full;
    const mainImg = document.getElementById('ProductMainImage');
    if (mainImg && full) {
      mainImg.src = full;
    }
    document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('active'));
    this.classList.add('active');
  });
});

// Cart page: quantity field updates trigger form auto-submit on change
document.querySelectorAll('.cart-table__qty').forEach(input => {
  input.addEventListener('change', function () {
    const form = this.closest('form');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });
});

// Product recommendations: fetch via Shopify's recommendations endpoint
const recoSection = document.getElementById('ProductRecommendations');
if (recoSection) {
  const url = recoSection.dataset.url;
  fetch(url)
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const grid = temp.querySelector('#ProductRecommendationsGrid');
      const target = document.getElementById('ProductRecommendationsGrid');
      if (grid && target && grid.innerHTML.trim()) {
        target.innerHTML = grid.innerHTML;
      } else if (target && !target.innerHTML.trim()) {
        recoSection.style.display = 'none';
      }
    })
    .catch(() => { recoSection.style.display = 'none'; });
}

// Variant price update
(function () {
  const productDataEl = document.querySelector('[data-product-json]');
  if (!productDataEl) return;

  const product = JSON.parse(productDataEl.textContent);

  function updatePrice(variant) {
    if (!variant) return;
    const formatted = (variant.price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    // Update main price display
    const priceEl = document.querySelector('.product-page__price');
    if (priceEl) {
      if (variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `<s>${(variant.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</s> ${formatted}`;
      } else {
        priceEl.textContent = formatted;
      }
    }

    // Update price in Add to Cart button
    const moneyEl = document.querySelector('.money-js');
    if (moneyEl) moneyEl.textContent = formatted;

    // Update hidden variant ID input
    const variantInput = document.getElementById('ProductSelectedVariant');
    if (variantInput) variantInput.value = variant.id;
  }

  document.querySelectorAll('select[name^="options"]').forEach(el => {
    el.addEventListener('change', function () {
      const selectedOptions = Array.from(
        document.querySelectorAll('select[name^="options"]')
      ).map(s => s.value);

      const variant = product.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      updatePrice(variant);
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {

  const notifyButton = document.querySelector('.product-page__add');

  if (notifyButton) {
    notifyButton.addEventListener('click', function () {

      if (window._klOnsite) {
        window._klOnsite.push(['openForm', 'XzvTxR']);
      } else {
        console.log('Klaviyo is not loaded.');
      }

    });
  }

});
